<template>
  <div v-if="inProgress" class="mt-16 flex space-x-10 overflow-hidden">
    <div v-for="index in 3" :key="index" class="w-[160px] flex-shrink-0">
      <div class="placeholder w-full h-[160px]"></div>
      <div class="mt-8 placeholder w-full h-10"></div>
      <div class="mt-4 placeholder w-full h-6"></div>
    </div>
  </div>
  <div v-else-if="listings.length > 2">
    <h3 class="font-bold text-lg uppercase">Recently viewed</h3>
    <div class="mt-10 pb-4 overflow-x-auto flex space-x-10">
      <RecentViewItem
        v-for="listing in listings"
        :key="listing.id"
        :listing="listing"
        :guestFavourites="guestFavourites"
        :checkoutPath="checkoutPath"
      />
    </div>
  </div>
</template>

<script>
import Http from "@/lib/Http"
import RecentViewItem from "@/components/Cart/RecentViewItem.vue"

export default {
  name: "Listing.RecentViews",
  props: {
    cart: {
      type: Object,
      required: true,
    },
    checkoutPath: {
      type: String,
      required: true,
    },
    guestFavourites: {
      type: [],
      required: false,
      default: [],
    },
  },
  components: {
    RecentViewItem,
  },
  data() {
    return {
      listings: [],
      inProgress: false,
    }
  },
  mounted() {
    this.fetchRecommendations()
  },
  computed: {
    apiUrl() {
      return "/api/suggestions/recent_views"
    },
    listingIds() {
      try {
        const recentViewsId = JSON.parse(localStorage.getItem("recentViewsId")) || []
        return recentViewsId
          .filter((id) => !this.cartListingIds.includes(id))
          .reverse()
          .slice(0, 10)
      } catch (e) {
        console.error("Error parsing recentViewsId from localStorage:", e)
        return []
      }
    },
    cartListingIds() {
      return this.cart.items.map((item) => item.listing.id)
    },
  },
  methods: {
    fetchRecommendations() {
      if (this.listingIds.length > 0) {
        this.inProgress = true
        Http.get(this.apiUrl, {
          params: {
            ids: this.listingIds,
          },
        }).then((response) => {
          this.listings = response.data.listings
          this.inProgress = false
        })
      }
    },
  },
}
</script>
